import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';import { Condition, UpdateConditionPhotoModel, AddComponentPhotoModel, AddThermalPhotoModel, AddSMUPhotoModel } from '../../models/interpretation.model';
import { ViewPhotoComponent } from '../view-photo/view-photo.component';
import { DomSanitizer } from '@angular/platform-browser';
import { FileReaderEvent } from '../../../../shared/models/FileReader';
import { NotificationsService } from 'angular2-notifications';
import { InterpretationService } from '../../interpretation.service';
import { UserService } from '../../../../shared/services/user.service';
import { heicTo } from 'heic-to';

@Component({
selector: 'condition-photo',
templateUrl: './condition-photo.component.html',
styleUrls: ['./condition-photo.component.scss']
})
export class ConditionPhotoComponent implements OnInit {
@Output() photoChange: EventEmitter<any> = new EventEmitter();
@Input() inspectionId: number;
@Input() photo: string;
@Input() condition: Condition;
@Input() inspectionDraftId: number;
@Input() equipmentId: number;
@Input() inspectionDetailId: number;
@Input() photoId: number;
@Input() isThermal:boolean=false;
@Input() isEquipmentSmuHrs:boolean=false;
@Input() side:number;
@Input() TphotoId:number;
@Input() isImagePathRequired:boolean=false;
@Input() isImageUrl:boolean=false;

Condition = Condition;
photoLoading = false;
isInspector = false;
isInterpreter = false;


constructor(private _dialog: MatDialog,
  private _sanitizer: DomSanitizer,
  private _interp: InterpretationService,
  private _notify: NotificationsService,
  private _user: UserService) { }

ngOnInit() {
  this.checkPermissions();
  console.log('photo',this.photo);
  console.log("inspectionId:", this.inspectionId);
}

checkPermissions() {
  this._user.getUserJobRoles().subscribe(
    jobRoles => {
      jobRoles.forEach(role => {
        switch (role.Name) {
          case 'Inspectors':
            this.isInspector = true;
            break;
          case 'Interpreters':
          case 'Super User':
          case 'Administrator':
            this.isInterpreter = true;
            this.isInspector = true;
            break;
            case 'Customer Admin':
              this.isInspector = true;
            this.isInterpreter = true;
              break;
        }
      });
    },
    error => {
      console.error(error);
      this._notify.error('Error', 'Unable to check your job roles. ');
    }
  );
}

viewConditionPhoto() {
  
  // console.log(this.inspectionDetailDraftId);
  const viewPhotoModalRef = this._dialog.open(ViewPhotoComponent, {
    autoFocus: false,
  restoreFocus: false,
  hasBackdrop: true,
    data: {
      inspectionId: this.inspectionId,
      conditionType: this.condition,
      isThermal:this.isThermal,
      isEquipmentSmuHrs: this.isEquipmentSmuHrs,
      side:this.side,

      inspectionDraftId: this.inspectionDraftId,
      equipmentId: this.equipmentId,

      inspectionDetailDraftId: this.inspectionDetailId,
      photoId: this.photoId,
      
      TphotoId:this.TphotoId,
      imageUrl: this.photo,
      isImageUrl : false    }
  });
  viewPhotoModalRef.afterClosed().subscribe(res => {
    console.log('Modal closed result = ', res);
    if (!res || typeof res !== 'object') {
      return;
    }
    if(res?.removed){
      this.photo = '';
      this.photoChange.emit({
      removed: true,
      imageUrl: null,
      imagePath: null
    });
    return;
    }
    if(res?.imageUrl != '' && res?.imageUrl != undefined){
      this.photo = res.imageUrl; // or res.imageUrl if needed
      console.log('res',res);
      this.photoChange.emit({
        removed: false,
        imageUrl: res.imageUrl,
        imagePath: res.imagePath
      });
    return;
    }
      //this.photoChange.emit({removed: false});
  });
}



private compressImage(src) {
  return new Promise((res, rej) => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      const elem = document.createElement('canvas');
      let width, height;
      width = img.width;
      height = img.height;

      // console.log('width', width)
      // console.log('height', height)

      var ratio = height / width; //cal aspect ratio
      let imageWidth = 800;//643
      var new_height = imageWidth * ratio; //calculate new height


      elem.width = imageWidth;
      elem.height = new_height;
      const ctx = elem.getContext('2d');
      ctx.drawImage(img, 0, 0, imageWidth, new_height);
      const data = ctx.canvas.toDataURL();
      res(data);
    }
    img.onerror = error => rej(error);
  })
}

async onSelectPhoto(event: any) {
  if (!(event.target.files && event.target.files[0])) {
    return;
  }

  this.photoLoading = true;
  // this._cdr.detectChanges();

  const file = event.target.files[0];

  const extension = file.name.split('.').pop()?.toLowerCase();
  const mimeType = (file.type || '').toLowerCase();

  const isHeic =
    extension === 'heic' ||
    extension === 'heif' ||
    mimeType.includes('heic') ||
    mimeType.includes('heif');

  const processFile = (f: File) => {
    const reader = new FileReader();

    reader.onload = (e: any) => {
      const imageUrl = e.target.result;

      this.compressImage(imageUrl)
        .then((res: string) => {
          if (res) {
            this.uploadPhoto(res.split(',')[1]);
          }
        })
        .catch((err) => {
          this.photoLoading = false;
          console.error(err);
        });
    };

    reader.readAsDataURL(f);
  };

  try {

    if (isHeic) {

      console.log("HEIC detected");

      const convertedBlob = await heicTo({
        blob: file,
        type: "image/jpeg",     // If your version doesn't support 'type', use 'toType'
        quality: 0.8
      });

      const convertedFile = new File(
        [convertedBlob as Blob],
        "converted.jpg",
        {
          type: "image/jpeg"
        }
      );

      processFile(convertedFile);

    } else {

      processFile(file);

    }

  } catch (err: any) {

    this.photoLoading = false;

    console.error("HEIC conversion failed", err);

    this._notify.error(
      'Error',
      'Unable to update the photo. Please contact support.'
    );

  }

  event.target.value = null;
}


  // onSelectPhoto(event: any) {
  //   if (event.target.files && event.target.files[0]) {
  //     this.photoLoading = true;
  //     //this._cdr.detectChanges();
  //     let file = event.target.files[0];
  //     const isHeic = file.type === "image/heic" || file.name.toLowerCase().endsWith(".heic");
  //     const processFile = (f: File) => {
  //       const reader = new FileReader();
  //       reader.onload = (e: any) => {
  //         const imageUrl = e.target.result;
  //         this.compressImage(imageUrl)
  //           .then((res: string) => {
  //             if (res) {
  //               this.uploadPhoto(res.split(',')[1]);
  //             }
  //           })
  //         };
  //       reader.readAsDataURL(f);
  //     };
  //     if (isHeic) {
  //       (heic2any as any).default({
  //         blob: file,
  //         toType: "image/jpeg",
  //         quality: 0.8
  //       })
  //       .then((result: any) => {
  //         const convertedBlob = Array.isArray(result) ? result[0] : result;
  //         const convertedFile = new File([convertedBlob], "converted.jpg", {
  //           type: "image/jpeg"
  //         });
  //         processFile(convertedFile);
  //       })
  //       .catch((err: any) => {
  //         this.photoLoading = false;
  //         console.error("HEIC conversion failed", err);
  //         this._notify.error('Error', 'Unable to update the photo. Please contact support.');
  //         //alert("Unable to process HEIC image");
  //       });
  //     } else {
  //       processFile(file);
  //     }
  //     event.target.value = null;
  //   }
  // }

// onSelectPhoto(event: any) {
//   if (event.target.files && event.target.files[0]) {
//     const reader = new FileReader();
//     reader.readAsDataURL(event.target.files[0]);
//     reader.onload = (event) => {
//       const imageUrl = (event.target["result"]);
//       this.compressImage(imageUrl).then((res: string) => {
//       if (res) {
//         this.uploadPhoto(res.split(',')[1]);
//       }
//       })
//     };
//   }
// }

uploadPhoto(newPhoto: string) {
  this.photoLoading = true;
  const photo = new UpdateConditionPhotoModel();
  photo.Condition = this.condition;
  photo.InspectionId = this.inspectionId;

  // console.log("isThermal",this.isThermal);
  // console.log("Side",this.side);
  // console.log("condition",this.condition);
  // console.log("inspectionId",this.inspectionId);
  // console.log("inspectionDraftId",this.inspectionDraftId);

photo.NewPhoto = newPhoto;
//Equipmentsmu upload start
if(this.isEquipmentSmuHrs){
const photo = new AddSMUPhotoModel();
photo.InspectionId = this.inspectionId;
photo.NewPhoto = newPhoto;
console.log("photo ", photo);
if(this.inspectionId !== undefined && this.inspectionId > 0)
{
  this._interp.updateInspectionSMUPhoto(photo.InspectionId,photo.NewPhoto).subscribe(r => {
    if (r.m_Item1 > 0) {
      this._notify.success('Uploaded', r.m_Item2);
      this.photoLoading = false;
      this.photoChange.emit({
        removed: false,
        imageUrl: newPhoto,
        imagePath: null
      });
    } else {
      this._notify.error('Failed', 'Unable to upload the photo. Please contact TrackTreads support. ');
      console.error(r.m_Item2);
      this.photoLoading = false;
    }
  });
}
else{
  this.photoLoading = false;
  this.photoChange.emit({
    removed: false,
    imageUrl: newPhoto,
    imagePath: null
  });
}


}
//Equipmentsmu upload End

else if(this.isThermal){
const thermalImage = new AddThermalPhotoModel();
thermalImage.InspectionId=this.inspectionId;
thermalImage.Side=this.side;
thermalImage.NewPhoto=newPhoto;
thermalImage.PhotoId=this.TphotoId
this._interp.addInspectionThermalImage(thermalImage).subscribe(r => {
  if (r.m_Item1 > 0) {
    this._notify.success('Uploaded', r.m_Item2);
    this.photoLoading = false;
      this.photoChange.emit();
  } else {
    this._notify.error('Failed', 'Unable to upload the photo. Please contact TrackTreads support. ');
    console.error(r.m_Item2);
    this.photoLoading = false;
  }
});
}
  else if (this.inspectionDraftId !== undefined && this.inspectionDetailId === undefined) {
    photo.InspectionId = this.inspectionDraftId;
    photo.EquipmentId = this.equipmentId;
    const photo1 = new AddComponentPhotoModel();
    photo1.InspectionId = this.inspectionDraftId;
    photo1.NewPhoto = newPhoto;
    if(this.isImagePathRequired){
      this._interp.addInspectionComponentPhoto(photo1).subscribe(r => {
         if (r.ImagePath != null && r.ImagePath != undefined) {
           this._notify.success('Updated', "Photo updated successfully");
           this.photoLoading = false;
           console.log('r',r);
           this.photoChange.emit({imagePath:r.ImagePath, imageUrl: r.ImageUrl});
         } else {
           this._notify.error('Failed', 'Unable to update the photo. Please contact TrackTreads support. ');
           this.photoLoading = false;
         }
      });
    }
    else {
       this._interp.updateInspectionDraftConditionPhoto(photo).subscribe(p => {
      if (p.m_Item1) {
        this._notify.success('Updated', p.m_Item2);
        this.photoLoading = false;
        this.photoChange.emit();
      } else {
        this._notify.error('Failed', 'Unable to update the photo. Please contact TrackTreads support. ');
        console.error(p.m_Item2);
        this.photoLoading = false;
      }
    }, err => {
      console.error(err);
      this.photoLoading = false;
      this._notify.error('Error', 'Unable to update the photo. Please contact TrackTreads support. ');
    });
    }
    // console.log(photo);
  } else if (this.inspectionDetailId !== undefined && this.photoId !== undefined) {
    const newPhotoModel = new AddComponentPhotoModel();
    newPhotoModel.InspectionDetailId = this.inspectionDetailId;
    newPhotoModel.InspectionId = this.inspectionDraftId;
    newPhotoModel.NewPhoto = newPhoto;
    this._interp.addInspectionComponentPhotoDraft(newPhotoModel).subscribe(r => {
      if (r.m_Item1 > 0) {
        this._notify.success('Uploaded', r.m_Item2);
        this.photoLoading = false;
      } else {
        this._notify.error('Failed', 'Unable to upload the photo. Please contact TrackTreads support. ');
        console.error(r.m_Item2);
        this.photoLoading = false;
      }
    });
  } else {
    this._interp.updateConditionPhoto(photo).subscribe(p => {
      if (p.m_Item1) {
        this._notify.success('Updated', p.m_Item2);
        this.photoLoading = false;
        this.photoChange.emit();
      } else {
        this._notify.error('Failed', 'Unable to update the photo. Please contact TrackTreads support. ');
        console.error(p.m_Item2);
        this.photoLoading = false;
      }
    }, err => {
      console.error(err);
      this.photoLoading = false;
      this._notify.error('Error', 'Unable to update the photo. Please contact TrackTreads support. ');
    });
  }

}

sanitize(image: string) {
  if (image === undefined) return '';
  return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
}
}
